import { render } from "./NewEditBlog.vue?vue&type=template&id=9a1add3a"
import script from "./NewEditBlog.vue?vue&type=script&lang=js"
export * from "./NewEditBlog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\saidd\\OneDrive\\Desktop\\AKSA\\Projekti\\udruzenje pravobranilaca\\Admin\\vue-notus\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__